import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  fill?: string;
  stroke?: string;
}

const LanguageIcon = (props: Props): ReactElement => {
  const { width, height, stroke, fill } = props;

  return (
    <svg
      width={width}
      height={height}
      stroke={stroke}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 12c0 2.157-.383 4.086-.983 5.456-.3.687-.645 1.21-1.002 1.556-.355.343-.697.488-1.015.488-.318 0-.66-.145-1.015-.488-.357-.346-.702-.87-1.002-1.556C9.383 16.086 9 14.156 9 12c0-2.157.383-4.086.983-5.456.3-.687.645-1.21 1.002-1.556.355-.343.697-.488 1.015-.488.318 0 .66.145 1.015.488.357.346.702.87 1.002 1.556.6 1.37.983 3.3.983 5.456zM5 9.5h14M5 15h14"
        stroke={stroke}
      />
      <circle cx="12" cy="12" r="7.5" stroke={stroke} />
    </svg>
  );
};

LanguageIcon.defaultProps = {
  width: '24px',
  height: '24px',
  fill: 'none',
  stroke: '#373d42',
};

export default LanguageIcon;
